package com.example.mystybag.commonData.helpers

object PlatformConfig {
    var isProductionEnvironment : Boolean? = null
}